/* global angular, imagesLoaded, $, _ */
angular.module('ua5App')
    .directive('calendarEvents', ['$state', '$timeout', '$rootScope', 'StringsFactory', function($state, $timeout, $rootScope, StringsFactory) {
        return {
            restrict: 'A',
            templateUrl: 'components/calendar-events/calendar-events.html',
            scope: {
                events: '=',
                dateString: '@'
            },
            link: function($scope, element, attrs) {

                $scope.$watch('events', function(newValue, oldValue) {
                    if (newValue) {
                        _.each($scope.events, function(post) {
                            var sortedTime;

                            if (
                                typeof post.eventData.startTime !== 'undefined' &&
                                post.eventData.startTime !== ''
                            ) {
                                sortedTime = StringsFactory.parseTime(post.eventData.startTime, post.eventData.startDate);
                            } else {
                                sortedTime = StringsFactory.parseTime('11:59 pm', post.eventData.startDate);
                            }
                            post.calcTime = parseFloat(sortedTime.valueOf());
                        });

                        $timeout(function() {
                            $('.clndr__event-list__event', element).each(function() {
                                imagesLoaded(this, function() {
                                    $scope.$emit('eventsImageLoaded');
                                });
                            });
                        });

                        $timeout(function() {
                            $scope.$emit('eventsLoaded');
                        }, 50);
                    }
                });

            }
        };
    }])
;
